<template>
    <div>
        <div>
            <div>
                <el-row>
                    <div class="left-justifying">
                        <h3>客户计费月报</h3>
                    </div>
                    <div class="right-justifying">
                        <!--<el-button type="info" plain size="small" @click="toRemove" v-if="deleteBtnExisted">
                            <i class="fa fa-times">
                            </i> 删除
                        </el-button>-->
                    </div>
                </el-row>
            </div>
            <div class="panel">
                <div class="panel-body">
                    <div class="advanced-search-location" style="right: 3%">
                        <el-button type="info" plain size="mini" @click="generatorBill">
                            <i class="fa fa-plus-circle">
                            </i> 生成账单
                        </el-button>
                        <el-button type="info" plain size="mini" @click="getCustomerBillMonthList">
                            <i class="fa fa-refresh">
                            </i> 刷新
                        </el-button>
                        <el-button type="info" plain size="mini" @click="back()">
                            <i class="fa fa-backward">
                            </i> 返回
                        </el-button>
                    </div>
                    <el-tabs v-model="activeTabName">
                        <el-tab-pane label="列表" name="list">
                        </el-tab-pane>
                        <el-tab-pane label="详情" name="detail" disabled>
                        </el-tab-pane>
                    </el-tabs>
                    <el-row>
                        <div>
                            <el-row class="bottom20" style="color: #909399;font-weight: 500" :gutter="10">
                                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                                    <el-col :xs="12" :sm="12" :md="8" :lg="8">
                                        账单类型：
                                    </el-col>
                                    <el-col :xs="12" :sm="12" :md="16" :lg="16">
                                        <el-select v-model="pageSearch.search.billType" class="width100"
                                                   :clearable="false" size="mini" @change="pageSearch.current=1">
                                            <el-option
                                                    v-for="(item,index) in options.customerBill"
                                                    :key="index"
                                                    :label="item.type"
                                                    :value="item.id"
                                            ></el-option>
                                        </el-select>
                                    </el-col>
                                </el-col>
                                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                                    <el-col :xs="12" :sm="12" :md="8" :lg="8">
                                        合同名称：
                                    </el-col>
                                    <el-col :xs="12" :sm="12" :md="16" :lg="16">
                                        <contract-select v-model="pageSearch.search.contractId" filterable
                                                         :width100="true" :clearable="true" size="mini" @change="pageSearch.current=1">

                                        </contract-select>
                                    </el-col>
                                </el-col>
                                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                                    <el-col :xs="12" :sm="12" :md="8" :lg="8">
                                        客户名称：
                                    </el-col>
                                    <el-col :xs="12" :sm="12" :md="16" :lg="16">
                                        <customer-select v-model="pageSearch.search.customerId" filterable
                                                         :width100="true" :clearable="true" size="mini" @change="pageSearch.current=1">

                                        </customer-select>
                                    </el-col>
                                </el-col>
                                <el-col :xs="12" :sm="12" :md="6" :lg="6">
                                    <el-col :xs="12" :sm="12" :md="8" :lg="8">
                                        月份：
                                    </el-col>
                                    <el-col :xs="12" :sm="12" :md="16" :lg="16">
                                        <el-date-picker v-model="pageSearch.search.beginMonth"
                                                        style="width: 35%"
                                                        value-format="yyyy-MM"
                                                        type="month"
                                                        placeholder="选择日期"
                                                        size="mini" class="width100"
                                                        @change="pageSearch.current=1"
                                        >
                                        </el-date-picker>
                                    </el-col>
                                </el-col>
                            </el-row>
                            <el-row class="bottom20">
                                <el-table v-loading="loading" :data="page.records" :key="Math.random()" element-loading-text="loading">
                                    <el-table-column prop="billTypeStr" fixed>
                                        <template slot="header" slot-scope="scope">
                                            合同名称<br>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-radio class="label-hidden" v-if="show.multMonthBill"
                                                      v-model="checked.multMonthBill"
                                                      @change="multiMonthContractBillRadioChange()"
                                                      :label="scope.row.contractId"></el-radio>
                                            {{scope.row.contractName}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="contractName" fixed>
                                        <template slot="header" slot-scope="scope">
                                            客户<br>
                                        </template>
                                        <template slot-scope="scope">
                                            {{scope.row.customerName}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column :prop="item.month" v-for="(item,index) in page.months"
                                                     :key="item.month" :min-width="100">
                                        <template slot="header" slot-scope="scope">
                                            <div v-if="show.multMonthBill">{{item.month}}</div>
                                            <el-radio v-if="show.multContractBill" v-model="checked.multContractBill"
                                                      @change="monthRadioChange(item.month)"
                                                      :label="item.month"></el-radio>
                                            <el-checkbox v-if="show.commonBill" v-model="item.all"
                                                         @change="allSelect(index,item)"
                                                         :label="item.month"></el-checkbox>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-checkbox class="label-hidden"
                                                         :label="commonBillLabel(scope.row,index)"
                                                         @change="saveBillId(scope.row.bills[index])"
                                                         v-if="scope.row.bills[index].billWorkflowStatus === 'CONFIRMED' &&commonBillCheckBoxStatus(item,index,scope.row) && (
                                                                 pageSearch.search.billType === 2 ||
                                                                 pageSearch.search.billType === 4 &&
                                                                 scope.row.bills[index].radioShow ||
                                                                 pageSearch.search.billType === 3 &&
                                                                 scope.row.bills[index].radioShow
                                                             )"
                                                         v-model="scope.row.bills[index].checked"></el-checkbox>
                                            <label :style="{color:scope.row.bills[index].color}"
                                                   :class="{'bill_detail_cursor' : scope.row.bills[index].color !== ''}"
                                                   @click="generatorBillDetail(scope.row.bills[index].color,scope.row.bills[index].billId,scope.row.bills[index].month)">
                                                {{scope.row.bills[index].value}}
                                            </label>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-row>
                            <el-row type="flex" class="row-bg" justify="end">
                                <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="pageSearch.current"
                                        :page-sizes="[10, 25, 50, 100]"
                                        :page-size="pageSearch.size"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="page.total">
                                </el-pagination>
                            </el-row>
                        </div>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import CustomerSelect from "@/views/billing/customer/component/customer.select"
    import ContractSelect from '@/views/billing/contract/component/contract.select'
    import {
        selectCustomerBillTypeOptions,  //账单类型选项
        selectCustomerBillMonthPage,    //分页显示客户计费月报
        generatorContractBill   //生成账单
    } from '@/api/billing';

    export default {
        name: 'billcustomergeneratorlist',
        data() {
            return {
                loading: null,
                activeTabName: 'list',  //激活的el-tab
                //控件显示状态
                show: {
                    commonBill: false,   //单月单合同账单选项框显示
                    commonBillDetail: false, //单月单合同账单列表子项选项框显示
                    multContractBill: false,//多合同账单选项框显示
                    multMonthBill: false,    //多月份账单选项框显示
                },
                //控件选中状态
                checked: {
                    multMonthBill: null,  //多月份账单合同列表的radio
                    multContractBill: null,   //多合同账单radio
                },
                //下拉框数据
                options: {
                    customerBill: [],
                },
                //搜索条件
                pageSearch: {
                    current: 1,
                    size: 10,
                    search: {
                        beginMonth: `${new Date().getFullYear()}-${new Date().getMonth() + 1 > 10 ? new Date().getMonth() + 1 : '0' + (new Date().getMonth() + 1)}`,
                        billType: null,
                        customerId: null,
                        contractId: null,
                    }
                },
                //分页结果
                page: {
                    total: 0,
                    records: [],
                    months: []
                },
                //生成账单需要的条件
                generator: {
                    billIds: new Set(),
                    billType: null
                }
            }
        },
        components: {
            "customer-select": CustomerSelect,
            "contract-select": ContractSelect
        },

        async created() {
            console.log('create');
             await this.getBillTypeOptions();
             /**
              * 设置页面之前的列表搜索条件
              * @type {string}
              * @see #getCustomerBillMonthList
              */
             let searchCase = localStorage.getItem('billing:contract:bill:customer:generator');
             if (null != searchCase) {
                 searchCase = JSON.parse(searchCase);
                 console.log("当前页",searchCase.current);
                 console.log("页大小",searchCase.size);
                 // this.$nextTick(() => {
                 this.pageSearch.search.billType = searchCase.search.billType;
                 this.pageSearch.search.beginMonth = searchCase.search.beginMonth;
                 this.pageSearch.search.contractId = searchCase.search.contractId;
                 this.pageSearch.search.customerId = searchCase.search.customerId;
                 this.pageSearch.size = searchCase.size;
                 this.pageSearch.current = searchCase.current;
                 this.page.total =  searchCase.totalCount;
                 // });
                 //应用本次搜索条件后置空
                 localStorage.removeItem('billing:contract:bill:customer:generator');
             }else{
                 await this.getCustomerBillMonthList();
             }
        },
        props: {},
        watch: {
            pageSearch: {
                handler: _.debounce(function () {

                    console.log('watch');
                    setTimeout(() => {
                        console.log(this.pageSearch.current);
                    }, 500)
                    this.getCustomerBillMonthList();
                }, 200),
                immediate: true,
                deep: true
            }
        },
        methods: {
            //返回
            back() {
                this.$router.push({
                    name: 'billcustomerlist',
                    query: {
                        deptType: this.$route.query.deptType
                    }
                });
            },
            /**
             * 检查单月单合同时是否应该显示该checkbox
             * @param row
             */
            commonBillCheckBoxStatus(item, index, row) {
                // console.log("row",JSON.stringify(row.billsMap[month]));
                return row.billsMap[item.month] != null && row.billsMap[item.month].canCreate;
            },
            commonBillLabel(row, index) {
                let last = row.bills[index].billId === null ? row.bills[index].month : row.bills[index].billId;
                return row.contractId + last;
            },
            handleSizeChange(val) {
                this.pageSearch.size = val;
            },
            handleCurrentChange(val) {
                this.pageSearch.current = val;
            },

            /**
             * 跳转到详情
             * @param billId 账单id
             * @param month 月份
             */
            generatorBillDetail(color, billId, month) {
                //setting data to sessionStorage
                let params = {
                    current: this.pageSearch.current,
                    size: this.pageSearch.size,
                    totalCount: this.page.total,
                    search: this.pageSearch.search
                }
                console.log("准备跳转详情", JSON.stringify(params));
                localStorage.setItem("billing:contract:bill:customer:generator", JSON.stringify(params));
                if (color !== '') {
                    this.$router.push({
                        name: 'billcustomerdetail',
                        params: {
                            deptType: this.$route.query.deptType,
                            customerBillDetail: {
                                billId: billId,
                                type: 'show',
                                op: null,
                                parent: 'billcustomergeneratorlist',
                                deptType: 3,  //列表類型 3=生成客戶賬單,
                                title: 'khjfyb',
                                month: month
                            }
                        }
                    });
                }
            },

            /**
             *  将billId存入要生成的账单ids
             *  @param row 当前行数据
             */
            saveBillId(row) {
                if(!['DRAFT', 'WAPPRNEW', 'WAPPRCHA', 'WACHA'].includes(row.billWorkflowStatus)) {
                    if (row.checked && row.canCreate) {
                        this.generator.billIds.add(row.billId);
                    } else {
                        this.generator.billIds.delete(row.billId);
                    }
                } else {
                }
            },

            /**
             * 生成账单
             */
            async generatorBill() {
                // this.$message.warning("请先选择要生成的账单");
                let param = {
                    billType: this.pageSearch.search.billType,
                    billIds: Array.from(this.generator.billIds)
                };
                if (Array.from(this.generator.billIds).length <= 0) {
                    this.$message.warning("请先选择要生成的账单");
                } else {
                    try {
                        let result = await generatorContractBill(param);
                        if (result.data.success) {
                            this.$message.success(result.data.data);
                            await this.getCustomerBillMonthList();
                        } else {
                            this.$message.error(result.data.responseMessage);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
            },

            /**
             * 全选
             * @param index 下标
             * @param item.month 月份
             */
            allSelect(index, item) {
                let checked = !!item.all;
                for (let i = 0; i < this.page.records.length; i++) {
                    for (let j = 0; j < this.page.records[i].bills.length; j++) {
                        if (item.month === this.page.records[i].bills[j].month) {
                            this.page.records[i].bills[j].checked = checked;
                        }
                    }
                    this.saveBillId(this.page.records[i].bills[index]);
                    // this.page.records[i].bills[index].checked=!this.page.records[i].bills[index].checked;
                }
            },

            /**
             * 多月份账单checkbox动态显示
             */
            multiMonthContractBillRadioChange() {
                for (let i = 0; i < this.page.records.length; i++) {
                    for (let j = 0; j < this.page.records[i].bills.length; j++) {
                        let radioShow = this.page.records[i].bills[j].canCreate &&
                            this.page.records[i].contractId === this.checked.multMonthBill;
                        this.page.records[i].bills[j].checked = false;
                        this.$set(this.page.records[i].bills[j], 'radioShow', radioShow);
                    }
                }
            },

            /**
             * 多合同账单checkbox动态显示
             */
            monthRadioChange() {
                for (let i = 0; i < this.page.records.length; i++) {
                    for (let j = 0; j < this.page.records[i].bills.length; j++) {
                        let radioShow = this.page.records[i].bills[j].canCreate &&
                            this.page.records[i].bills[j].month === this.checked.multContractBill;
                        if (radioShow && this.page.records[i].bills[j].checked) {
                            this.generator.billIds.add(this.page.records[i].bills[j].billId);
                        } else {
                            this.generator.billIds.delete(this.page.records[i].bills[j].billId);
                        }
                        this.page.records[i].bills[j].checked = false;
                        this.$set(this.page.records[i].bills[j], 'radioShow', radioShow);
                    }
                }
            },

            /**
             * 查询客户账单列表
             * @returns {Promise<void>}
             */
            async getCustomerBillMonthList() {
                this.generator.billIds.clear();
                let params = {
                    pageNum: this.pageSearch.current,
                    pageSize: this.pageSearch.size,
                    billType: this.pageSearch.search.billType,
                    contractId: this.pageSearch.search.contractId,
                    customerId: this.pageSearch.search.customerId,
                    beginMonth: this.pageSearch.search.beginMonth
                };
                try {
                    this.loading = true;
                    let result = await selectCustomerBillMonthPage(params);
                    let records = result.data.data.list.records;
                    records.forEach(record => {
                        record.billsMap = _.keyBy(record.bills, 'month');
                    });
                    this.page.months = result.data.data.months;
                    this.page.records = records;
                    this.page.total = result.data.data.list.total;
                    //this.pageSearch.current = result.data.data.list.current;
                    //this.pageSearch.size = result.data.data.list.size;
                    this.show.commonBill = result.data.data.commonBillShow;   //单月单合同账单选项框显示
                    if (this.show.commonBill) {
                        this.show.commonBillDetail = true;
                    }
                    this.show.multContractBill = result.data.data.multContractBillShow;//多合同账单选项框显示
                    this.show.multMonthBill = result.data.data.multMonthBillShow;    //多月份账单选项框显示
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    this.$message.warning("获取数据超时,请稍后重试");
                    console.log(e);
                }
            },

            /**
             * 获取账单类型下拉框选项
             * @returns {Promise<void>}
             */
            async getBillTypeOptions() {
                try {
                    let result = await selectCustomerBillTypeOptions();
                    this.options.customerBill = result.data.data;
                    if (this.options.customerBill.length > 0) {
                        this.pageSearch.search.billType = this.options.customerBill[0].id;
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            formatAmount(value) {
                return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            },
        },
    }
</script>

<style scoped>
    .bill_detail_cursor {
        cursor: pointer;
    }

    .bill_detail_cursor:hover {
        text-decoration: underline;
    }
</style>
